<template>
    <div>
        <loader v-if="loading"></loader>
        <div v-else>
            <div class="m-5" v-if="data">

                <b-modal :busy="saving" id="modal-update" title="Update Driver Company" @ok="update" v-if="!loading"
                         :disabled="saving">
                    <b-form @submit.prevent.stop="update">
                        <b-form-group>
                            <b-form-input id="name" type="text" required placeholder="Company Name"
                                          v-model="data.name"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="commercial" type="text" required placeholder="Commercial Name"
                                          v-model="data.commercial"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-datepicker id="foundedYear" required placeholder="Founded Year"
                                               v-model="data.foundedYear"></b-form-datepicker>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="taxNumber" type="text" required placeholder="Tax Number"
                                          v-model="data.taxNumber"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="invoiceAddress" type="text" required placeholder="Invoice Address"
                                          v-model="data.invoiceAddress"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="ibanName" type="text" required placeholder="IBAN Name"
                                          v-model="data.ibanName"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="ibanNumber" type="text" required placeholder="IBAN Number"
                                          v-model="data.iban"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="email" type="email" required placeholder="Email"
                                          v-model="data.email"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="commission" type="number" required placeholder="Commission Rate"
                                          v-model="data.commission"></b-form-input>
                        </b-form-group>
                    </b-form>
                </b-modal>

                <div class="row">
                    <div class="col-lg-6">
                        <dl class="row">
                            <dt class="col-sm-5">Company:</dt>
                            <dd class="col-sm-7">{{data.name}}</dd>
                            <dt class="col-sm-5">Commercial Title:</dt>
                            <dd class="col-sm-7">{{data.commercial}}</dd>
                            <dt class="col-sm-5">Founded Year:</dt>
                            <dd class="col-sm-7">{{data.foundedYear}}</dd>
                            <dt class="col-sm-5">Tax Number:</dt>
                            <dd class="col-sm-7">{{data.taxNumber}}</dd>
                            <dt class="col-sm-5">Invoice Address:</dt>
                            <dd class="col-sm-7">{{data.invoiceAddress}}</dd>
                            <dt class="col-sm-5">Commission Rate:</dt>
                            <dd class="col-sm-7">{{data.commission}}</dd>
                        </dl>
                    </div>
                    <div class="col-lg-6">
                        <dl class="row">
                            <dt class="col-sm-5">IBAN Name:</dt>
                            <dd class="col-sm-7">{{data.ibanName}}</dd>
                            <dt class="col-sm-5">IBAN:</dt>
                            <dd class="col-sm-7">{{data.iban}}</dd>
                            <dt class="col-sm-5">Email:</dt>
                            <dd class="col-sm-7">{{data.email}}</dd>
                            <dt class="col-sm-5">Created At:</dt>
                            <dd class="col-sm-7">{{data.createdAt | moment("dddd, MMMM Do YYYY, h:mm:ss a")}}</dd>
                            <dt class="col-sm-5">Updated At:</dt>
                            <dd class="col-sm-7">{{data.updatedAt | moment("dddd, MMMM Do YYYY, h:mm:ss a")}}</dd>
                        </dl>
                    </div>
                </div>

                <b-button class="ml-auto" size="sm" variant="info" v-b-modal.modal-update>Update</b-button>
            </div>
            <div class="text-center m-5" v-else>
                <b-modal :busy="saving" id="modal-create" title="Create Driver Company" @ok="create" v-if="!loading"
                         :disabled="saving">
                    <b-form @submit.prevent.stop="create">
                        <b-form-group>
                            <b-form-input id="name" type="text" required placeholder="Company Name"
                                          v-model="createForm.name"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="commercial" type="text" required placeholder="Commercial Name"
                                          v-model="createForm.commercial"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-datepicker id="foundedYear" required placeholder="Founded Year"
                                               v-model="createForm.foundedYear"></b-form-datepicker>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="taxNumber" type="text" required placeholder="Tax Number"
                                          v-model="createForm.taxNumber"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="invoiceAddress" type="text" required placeholder="Invoice Address"
                                          v-model="createForm.invoiceAddress"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="ibanName" type="text" required placeholder="IBAN Name"
                                          v-model="createForm.ibanName"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="ibanNumber" type="text" required placeholder="IBAN Number"
                                          v-model="createForm.iban"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="email" type="email" required placeholder="Email"
                                          v-model="createForm.email"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input id="commission" type="number" required placeholder="Commission"
                                          v-model="createForm.commission"></b-form-input>
                        </b-form-group>
                    </b-form>
                </b-modal>
                <h5 class="card-title">Company Not Found</h5>
                <p class="card-text">
                    <b-button size="lg" variant="info" v-b-modal.modal-create>Create</b-button>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentLoader from '../../../../components/ContentLoader';
    import GetDriverCompanies from '../../../../store/actions/getDriverCompanies';
    import CreateDriverCompany from '../../../../store/actions/createDriverCompany';
    import UpdateDriverCompany from '../../../../store/actions/updateDriverCompany';
    import ShowError from "../../../../helpers/showError";

    export default {
        name: 'UserCompany',
        components: {
            loader: ContentLoader,
        },
        data() {
            return {
                loading: false,
                saving: false,
                data: false,
                createForm: {
                    commission: undefined,
                    name: undefined,
                    commercial: undefined,
                    foundedYear: undefined,
                    taxNumber: undefined,
                    ibanName: undefined,
                    iban: undefined,
                    email: undefined,
                    invoiceAddress: undefined,
                    user: {id: this.$route.params.id},
                },
            }
        },
        async created() {
            this.load();
        },
        methods: {
            async update() {
                try {
                    this.saving = true;
                    await UpdateDriverCompany(this.data, this.data.id);
                    this.load();
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.saving = false;
                }
            },
            async create() {
                try {
                    this.saving = true;
                    await CreateDriverCompany(this.createForm);
                    this.load();
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.saving = false;
                }
            },
            async load() {
                try {
                    this.loading = true;
                    const result = await GetDriverCompanies(this.$route.params.id);
                    if (result.data.length > 0) {
                        this.data = result.data[0];
                    } else {
                        this.data = false;
                    }
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>
